<template>
  <section class="children-component" v-show="ready">
    <v-container>
      <v-row justify="space-between" class="my-3">
        <v-col cols="12" md="6">
          <h1 class="header-title optus-highlight optus-highlight--yellow">
            Children&nbsp;
          </h1>
        </v-col>
        <v-col cols="12" md="3">
          <v-fade-transition>
            <div class="text-md-right text-center sm:mt-4">
              <v-btn
                color="primary"
                v-if="children && children.length"
                @click="toggleCreate"
              >
                <v-icon left>
                  {{ newChild ? 'close' : 'add' }}
                </v-icon>
                {{ newChild ? 'Cancel' : 'New Child' }}
              </v-btn>
            </div>
          </v-fade-transition>
        </v-col>
      </v-row>
      <v-row class="minus-gap">
        <v-slide-y-transition>
          <v-col
            lg="4"
            md="6"
            sm="12"
            v-show="children && (newChild || !children.length)"
          >
            <new-child :newChild.sync="newChild" />
          </v-col>
        </v-slide-y-transition>
        <v-col
          v-for="(child, index) in children"
          :key="index"
          lg="4"
          md="6"
          sm="12"
        >
          <child-card @manageChild="switchAccount(me, child)" :data="child" />
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import ChildCard from './ChildCard'
import Auth from '@/modules/auth/models/Auth'
import NewChild from './NewChild'
import Parent from '@/modules/parent/models/Parent'
import Individual from '@/modules/individual/models/Individual'
import { mapMutations } from 'vuex'
import switchAccount from '@/modules/auth/mixins/switchAccount'
import Lesson from '@/modules/lesson/models/Lesson'

export default {
  name: 'Children',
  mixins: [switchAccount],
  components: {
    NewChild,
    ChildCard
  },
  data() {
    return {
      ready: false,
      newChild: false
    }
  },
  computed: {
    children() {
      return Individual.all()
    },
    me() {
      return Auth.query()
        .where('type', 'parent')
        .first()
    }
  },
  async mounted() {
    this.$store.state.loading = true
    await Parent.dispatch('getChildren')
    await Lesson.dispatch('fetch', this.$route.meta.type)
    setTimeout(() => {
      this.ready = true
      this.$store.state.loading = false
    })
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    toggleCreate() {
      this.newChild = !this.newChild
      this.$router.push({
        query: Object.assign({}, this.$route.query, { newChild: this.newChild })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header-title {
  margin-top: 0 !important;
}
</style>
